import { logEvent } from './core/log-event'
import { initialize } from './core/initialize'
import { useGetExperiment, getExperiment } from './features/experiment'
import { getFeatureGate, useFeatureGate } from './features/feature-gate'
import { setStatsigEnvTier } from './session/session'
import {
  useStatsigFeatureGate,
  useStatsigFeatureGateValue,
  useStatsigExposure,
} from './hooks/useStatsigFeatureGate'

export const Statsig = {
  initialize,
  logEvent,
  getExperiment,
  useGetExperiment,
  getFeatureGate,
  useFeatureGate,
  setStatsigEnvTier,
  useStatsigFeatureGate,
  useStatsigFeatureGateValue,
  useStatsigExposure,
}

export type { ExperimentConfig, FeatureGate } from './types'
